import { cn } from '../utils/utils'

export function PriceDiff({ value, label, className }: { value: number; label: string; className?: string }) {
    const sign = value > 0 ? '+' : value < 0 ? '-' : ''
    const trimmed = (label || '').toString().trim()
    const hasLeadingSign = /^[+-]/.test(trimmed)

    return (
        <span
            className={cn(
                'text-primary leading-snug inline-flex items-center',
                {
                    'text-neutral-500': value === 0,
                    'text-success': value > 0,
                    'text-destructive': value < 0,
                },
                className,
            )}
        >
            {sign && !hasLeadingSign ? sign : ''}
            {label}
        </span>
    )
}
